import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import BankRoll from "../../Components/Game/BankRoll";
import Queue from "../../Components/Game/Queue";
import TopBarGames from "../../Components/Game/Addons/TopBar";
import Game from "./Game";
import Bet from "./Bet";
import Engine from "./Engine";
import { isMobile, wait, Event } from "../../../Helper";
import Loading from "../Loading";
import "../../../Static/css/hash_dice.css";
import BetsPopHashDice from "./Graph";

class Index extends React.Component {
  _Mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: new Engine(),
      margin: "mt-3",
      showPopup: false,
    };
    this.handleShowPopUp = this.handleShowPopUp.bind(this);
  }

  handleShowPopUp() {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
    }));
  }
  componentDidMount() {
    this._Mounted = true;
    let { engine } = this.state;

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Start Engine
    engine.started = true;

    wait(600).then(() => {
      this.handleResize();
    });
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    let { engine } = this.state;
    window.removeEventListener("resize", this.handleResize);

    wait(300).then(() => {
      this._Mounted = false;
    });

    // Stop Engine
    engine.started = false;
    engine.trigger = null;
    engine.off();
  }

  handleResize() {
    let clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;

    if (clientWidth < 1540) {
      this.setState({ col: "col-xl-12" });
      Event.emit("hide_games");
    } else {
      this.setState({ col: "col-xl-9" });
      Event.emit("show_min_games");
    }

    if (isMobile()) {
      this.setState({ padding: "p-0", margin: "mt-1", ovh: "ovh" });
    }
  }
  render() {
    let { col, padding, margin, ovh } = this.state;

    const help = (
      <>
        <p className={"font-light text-white font-15"}>
          Hash Dice is a game of betting below or under the number 50000 by the
          payout. If you choose “low” that means the number must come in under
          49999 and higher than your payout. If you choose “High” that means
          number must come in 50000 or over than your payout. First you will
          choose your bet amount and the payout multiplier and then your
          variance (low/high). The payout is the x amount times your bet amount
          that you will win.
        </p>
        <p className={"font-light text-white font-15"}>
          Example: If you bet .10 on low variance with a payout of 5 and the
          number comes out as 35987 you win 5x your bet amount. If the number
          rolled is 50000 or over you lose the bet.
        </p>
        <h4 className="text-white text-success">Provaily Fair ?</h4>
        <p className={"font-light text-white font-15 l26"}>
          To generate a roll number between 0 and 99,999: <br />
          First we calculate the hash value of the combination with HMAC_SHA512.
          This gives us a 64-character hexadecimal string: hash = HMAC_SHA512
          (clientSeed:nonce, serverSeed).
          <br />
          We then take the first 5 characters of that hash and convert them to a
          decimal number ranging from 0 to 1,048,575 (16 ^ 5 - 1). <br />
          If it is less than 1 million, we divide it by 100,000 and use it as
          your roll outcome. Otherwise, we repeat using the next five
          characters. We are able to repeat the process up to 25 times.
          <br />
          In the very rare case ((48,576 / 1,000,000) ^ 25) that none of the 25
          trials are lower than 1 million when converted to decimal, we use the
          remaining 3 characters and convert them to your roll number.
          <br />
        </p>
      </>
    );

    return (
      <>
        <Helmet>
          <title>Hash Dice</title>

          <link rel="canonical" href="/hash-dice" />
        </Helmet>
        <div>
          {this._Mounted ? (
            <div
              className={`${col} ${padding}`}
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                maxWidth: "3000px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.state.showPopup && (
                <BetsPopHashDice
                  onClose={this.handleShowPopUp}
                  engine={this.state.engine}
                />
              )}
              <Row className={"animated fadeIn " + ovh}>
                <div className="d-none">
                  Crypto Hash Dice Game Description: {help}
                </div>
                <Col sm={12} className={"m-auto " + col + " " + padding}>
                  <div className="mine-containers" style={{ height: "100%" }}>
                    <div className="game-containers">
                      <div
                        className="game-header"
                        style={{
                          // width: "100%",
                          // height: "100%",  // Use 100vh for full viewport height
                          padding: "3px 10px",
                          backgroundColor: "#17181b",
                          display: "flex",
                          justifyContent: "center", // Center the container horizontally
                          alignItems: "center", // Center the container vertically
                          boxSizing: "border-box", // Ensure padding doesn't affect the width/height
                          opacity: 0.9,
                          // borderTopLeftRadius: "1rem",  // Top-left corner rounded
                          borderTopRightRadius: "1rem", // Top-right corner rounded
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            gap: "10px",
                            // border:"2px solid red",   // Allow wrapping on smaller screens
                          }}
                        >
                          {/* First Circle */}
                          {/* <div
                            className="header-content"
                            style={{
                              borderRadius: "2rem", // Ensure it is circular
                              width: "100%", // Adjust width as a percentage for responsiveness
                              height: "100%", // Fixed height for the div
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center", // Vertically centers content
                              alignItems: "center", // Horizontally centers content
                              textAlign: "center",
                              color: "white",
                              boxSizing: "border-box",
                              flex: "2",
                              padding: "5px",
                              // overflow:"hidden",
                              whiteSpace: "nowrap", // Prevent text from wrapping
                              textOverflow: "ellipsis",
                            }}
                          >
                            <p
                              className="game-header"
                              style={{
                                margin: 0,
                                width: "100%",
                                // border: "2px solid red", // Red border for testing
                                color: "white",
                                borderRadius: "2rem",
                                backgroundColor: "#26272c",
                                padding: "1px", // Add padding to create space around text
                              }}
                            >
                              <span
                                className="game-header"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#43b309",
                                }}
                              >
                                BankRoll
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  padding: "0px 3px",
                                  fontWeight: "bold",
                                  color: "gray",
                                }}
                                className="game-header"
                              >
                                INR
                              </span>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "gray",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                  margin: " 0", // Added margin for separation between the elements
                                }}
                                className="game-header"
                              >
                                <img
                                  src="/assets/images/inr.png"
                                  alt="img"
                                  style={{ width: "21px", padding: "0px 1px" }}
                                />
                                <span className="game-header">2842.002</span>
                              </p>
                            </p>
                          </div> */}

                          {/* Second Circle */}
                          {/* <div 
                                        style={{
                                            // border: "2px solid yellow", 
                                            borderRadius: "2rem",  // Ensure it is circular
                                            width: "100%",         // Adjust width as a percentage for responsiveness
                                            height: "100%",      // Fixed height, same as above for uniformity
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center", 
                                            textAlign: "center", 
                                            color: "white", 
                                            fontSize: "15px",
                                            fontWeight:"bold",
                                            padding: "13px",
                                            boxSizing: "border-box",
                                            flex:"3",
                                            backgroundColor: "#26272c",
                                            color:"gray",
                                            overflow:"hidden"
                                        }}
                                        className='fontChange'
                                    >
                            
                                Game results will be displayed here.
                                
                                    </div> */}
                        </div>
                      </div>

                      {/* GAME */}
                      <Card
                        className="mb-0"
                        style={{
                          backgroundImage:
                            "url(/assets/images/hashdice-bg.jpg)",
                          backgroundSize: "cover", // Ensures the image covers the whole card
                          objectFit: "cover",
                          width: "100%",
                          backgroundPosition: "center", // Centers the image
                          opacity: "0.9",
                          backgroundRepeat: "no-repeat", // Prevents image repetition if smaller than the card
                        }}
                      >
                        <Card.Body
                          className={"bg-dice-options hash_diceBG"}
                          id="roll-panel"
                        >
                          <Row>
                            <Col sm={12} md={12} className={"m-auto"}>
                              <Game engine={this.state.engine} />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="bet-containers">
                      {/* BET */}
                      <Card
                        className="mb-0 bet-body"
                        style={{ backgroundColor: "#17181b", height: "100%" }}
                      >
                        <Card.Body className={padding}>
                          <Row>
                            <Col sm={12} md={12} className={""}>
                              <Bet engine={this.state.engine} />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  {/* BANKROLL */}
                  <Card
                    className="mb-0"
                    style={{
                      backgroundColor: "#17181b",
                      borderBottomLeftRadius: "1rem",
                      borderBottomRightRadius: "1rem",
                    }}
                  >
                    <Card.Body className="px-2 py-3">
                      <Row>
                        <Col md={6} className={"col-6 text-left"}>
                          <BankRoll game={"hash_dice"} />
                        </Col>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            right: "1px",
                            width: "40%",
                          }}
                        >
                          <Col
                            md={12}
                            className={"col-12 text-right"}
                            style={{
                              display: "flex",
                              gap: "8px",
                              justifyContent: "flex-end",
                              textAlign: "center",
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                          >
                            <TopBarGames
                              help={help}
                              image="/assets/images/covers_new/____hilo.png"
                            />
                            <div
                              onClick={this.handleShowPopUp}
                              style={{
                                alignItems: "center",
                                height: "37px",
                                width: "37px",
                                borderRadius: "5px",
                                backgroundColor: "#17181b",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                style={{ height: "19px", width: "19px" }}
                                src="/assets/images/nanoicons/nanoswap.png"
                                alt="Swap"
                              />
                            </div>
                          </Col>
                        </div>
                      </Row>
                    </Card.Body>
                  </Card>

                  {/* QUEUE */}
                  <Card
                    className="mb-5 mt-1"
                    style={{ borderRadius: "1rem", backgroundColor: "#17181b" }}
                  >
                    <Card.Body className="p-1">
                      <Row>
                        <Col sm={12} md={12} className={"m-auto px-1"}>
                          <Queue t={this.props.t} game={"hash_dice"} />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

export default Index;
